<template>
    <div class="account-exists-page">
        <div class="account-exists-page__content">
            <logos-container-ui center />
            <div class="account-exists-page__title">
                <h1>
                    {{ $t('Account Already Exists') }}
                </h1>
            </div>
            <div class="account-exists-page__description" v-if="!showSuccess">
                <div>
                    <p>
                        {{ $t(`It seems the phone number or email address you entered is already linked to an existing account.`) }} <br> <br>
                        {{$t('Here are the details for your reference:') }} <br>
                        {{$t('Email: ')}} <strong>{{ email }} </strong> <br>
                        {{$t('Phone: ')}} <strong>{{ phone }} </strong> <br> <br>
                        {{ $t(`If this account belongs to you, you can log in, recover your password, or update the associated information.`) }}
                    </p>
                </div>
                <div class="account-exists-page__separator">
                    <span class="account-exists-page__separator-text">
                        {{ $t('Or') }}
                    </span>
                </div>
                <div>
                    <p class="account-exists-page__update-info text-muted">
                        {{ $t('Updaye your informatio to access.') }}
                        <button class="account-exists-page__link btn btn-link p-0" @click="$refs.updateInfo.show()">
                            {{ $t('Change It') }}
                        </button>
                    </p>
                </div>
                
                <ui-button class="account-exists-page__button w-100">
                    {{ $t('Back to login.') }}
                </ui-button>
            </div>
            <div v-else>
                <h4>
                    {{ $t('Information updated successfully.') }} <br>
                </h4>
                <span class="fa fa-spinner fa-spin" />
                {{ $t('You will be redirected to the login page in a few seconds') }}
            </div>
            <p class="account-exists-page__support-message">
                {{ $t('If you are still having problems with login, start a support chat') }}.
            </p>
            <update-information ref="updateInfo" :user="user" :update="true"  @accountInformationUpdated="infoupdated"/>
        </div>
    </div>
</template>

<script>
import LogosContainerUi from '@/components/ui/LogosContainer.vue'
import UiButton from '@/components/ui/buttons/Button.vue'
import UpdateInformation from '@/components/accounts/PendingAccountInformationModal.vue';

export default {
    components: {
        LogosContainerUi,
        UiButton,
        UpdateInformation,
    },
    data() {
        return {
            site_id: this.$route.query.site_id,
            email: '',
            phone: '',
            user: {},
            showSuccess: false,
        }
    },
    async mounted() {
        if (!this.$cookies.get('_atid')) {
            this.$router.push('/');
        }
        await this.getAccountDetails();
        await this.getAccount();
    },
    methods: {
        async getAccountDetails() {
            try {
                const data = this.$route.query.data;
                let credentials = Buffer.from(data, 'base64').toString();
                let index = credentials.indexOf(':');
                this.email = credentials.substring(0, index);
                this.phone = credentials.substring(index + 1);
            } catch (error) {
                this.showError(error);
            }
        },
        async getAccount() {
            try {
                this.loadingAccount = true;

                const { data } = await this.axiosAccount.get('/api/accounts/me');

                this.user = data;
            } catch(error) {
                this.handleErrors(error, 'accounts');
            } finally {
                this.loadingAccount = false;
            }
        },
        infoupdated(data) {
            this.user = data;
            this.showSuccess = true;
            setTimeout(() => {
                this.$cookies.remove('_atid');
                window.location.replace('/login');
            }, 5000);
        }
    }
};
</script>

<style lang="scss">
.account-exists-page {
    text-align: center;
    position: relative;

    &__back {
        position: absolute;
        left: 0;
        top: 0;
    }

    &__content {
        max-width: 650px;
        margin-left: auto;
        margin-right: auto;
    }

    &__logo {
        margin-bottom: 35px;
    }

    &__support-message {
        color: #c4c4c4;
        font-size: 0.875rem;
        font-weight: 400;
        margin-bottom: 0;
    }

    &__img {
        max-width: 120px;
        width: 100%;
    }

    &__button {
        margin-bottom: 20px;
    }

    &__separator {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
        position: relative;
    }

    &__separator-text {
        font-size: 14px;
        color: #9093A1;
        font-weight: 500;
        padding-left: 10px;
        padding-right: 10px;

        &::after {
            background-color: #f0f0f0;
            content: '';
            height: 1px;
            left: 0;
            position: absolute;
            top: calc(50% - 1px);
            width: calc(50% - 18px);
        }

        &::before {
            background-color: #f0f0f0;
            content: '';
            height: 1px;
            position: absolute;
            right: 0;
            top: calc(50% - 1px);
            width: calc(50% - 18px);
        }
    }

    &__update-info {
        color: #9093A1;
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 24px;
    }
        
    &__link {
        color: $accounts-secondary !important;
        font-weight: 600 !important;
        font-size: 16px !important;
        text-decoration: none;
    }

}
</style>